<div
  class="surface-ground flex align-items-center justify-content-center overflow-hidden p-4"
  style="position: fixed; inset: 0; z-index: 9999"
>
  <div class="flex flex-column align-items-center justify-content-center">
    <img
      src="assets/brand/{{
        layoutService.colorScheme() === 'light' ? 'logo-light' : 'logo-dark'
      }}.png"
      alt="Sequal App Logo"
      class="mb-5 w-6rem flex-shrink-0"
    />
    <div
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(
          180deg,
          rgba(33, 150, 243, 0.4) 10%,
          rgba(33, 150, 243, 0) 30%
        );
      "
    >
      <div
        class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center text-center"
        style="border-radius: 53px; max-width: 30rem"
      >
        <i class="pi pi-compass text-blue-500 mb-4" style="font-size: 3.5rem"></i>
        <h1 class="text-900 font-bold text-3xl lg:text-4xl mb-3">
          We couldn't find that page
        </h1>
        <p class="text-600 text-lg line-height-3 mb-5" style="max-width: 24rem">
          Sorry about that. The page you're looking for may have been moved,
          renamed, or might never have existed. Let's get you back on track.
        </p>
        <div class="flex flex-column sm:flex-row gap-3 w-full justify-content-center">
          <button
            pButton
            type="button"
            icon="pi pi-home"
            label="Back to Home"
            [rounded]="true"
            [routerLink]="CommonRoute.ADMIN_HOME"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
